import { EmriLakimi, EmriNumri, EmriPrapashtesa, EmriRasa, EmriTrajta } from '@core/enums/emri.enum';

export class EmriConstants {
  public static EmriGjiniaVecoria = [
    { id: 10, short: 'm.', long: 'Mashkullore' },
    { id: 11, short: 'f.', long: 'Femërore' },
    { id: 12, short: 'as.', long: 'Asnjanëse' },
  ];

  public static EmriGjiniaNenvecoria1 = [{ id: 10, short: 'amb.', long: 'Ambigjenë' }];

  public static EmriLakimi = [
    { id: 10, short: 'lak.I', long: 'I parë' },
    { id: 11, short: 'lak.II', long: 'I dytë' },
    { id: 12, short: 'lak.III', long: 'I tretë' },
    { id: 13, short: 'lak.IV', long: 'I katërt' },
  ];

  public static EmriNumri = [
    { id: 10, short: 'nj.', long: 'njëjës' },
    { id: 11, short: 'sh.', long: 'shumës' },
  ];

  public static EmriRasa = [
    { id: 10, short: 'e.', long: 'Emërore' },
    { id: 11, short: 'gj.', long: 'Gjinore (i,e,të,së)' },
    { id: 12, short: 'dh.', long: 'Dhanore' },
    { id: 13, short: 'k.', long: 'Kallëzore' },
    { id: 14, short: 'rr.', long: 'Rrjedhore (prej ...)' },
  ];

  public static EmriRasaC = [
    { id: 10, short: 'e.', long: 'Emërore' }
  ]

  public static EmriTrajta = [
    { id: 11, short: 'pashq.', long: 'E pashquar' },
    { id: 10, short: 'shq.', long: 'E shquar' },
  ];

  public static EmriTrajtaC = [
    { id: 11, short: 'pashq.', long: 'E pashquar' },
  ]

  public static EmriShumesi = [
    { id: 10, short: 'sn.', long: 'Si njëjësi' },
    { id: 11, short: 'p.', long: 'Me prapashtesa' },
    { id: 12, short: 'nt.', long: 'Me ndërrime tingujsh' },
    { id: 13, short: 'ntp.', long: 'Me ndërrime tingujsh dhe prapashtesë' },
    { id: 14, short: 'ntt.', long: 'Ndërrime të tjera tingujsh' },
    { id: 15, short: 'nnm.', long: 'Me një ndryshim të madh' },
    { id: 16, short: 'fs.', long: 'Me formë supletive' },
  ];

  public static EmriFormaFjales = [
    { id: 10, short: "ç'", long: "ç'" },
  ];

  public static EmriFormimiVecoria = [
    { id: 10, short: 'par', long: 'E parme' },
    { id: 11, short: 'jopar', long: 'Jo e parme' },
  ];

  public static EmriFormimiNenvecoria1 = [
    { id: 10, short: 'prej.', long: 'Prejardhje' },
    { id: 11, short: 'nyj.', long: 'Nyjëzim' },
    { id: 12, short: 'komp.', long: 'Kompozim' },
    { id: 13, short: 'përngj.', long: 'Përngjitje' },
    { id: 14, short: 'konv.', long: 'Konverzion' },
    { id: 15, short: 'përz.', long: 'Të përziera' },
  ];

  public static EmriLlojiVecoria = [
    { id: 10, short: 'përgj.', long: 'I përgjithshëm' },
    { id: 11, short: 'përv.', long: 'I përveçëm' },
    { id: 12, short: 'përm.', long: 'Përmbledhës' },
    { id: 13, short: 'lënd.', long: 'Lënde' },
  ];

  public static EmriLakimiStructure = [
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Emerore, left: 'E.', middle1: null, middle2: 'i' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Gjinore, left: 'Gj. (i...)', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Dhanore, left: 'Dh.', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Kallezore, left: 'K.', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Rrjedhore, left: 'Rr. (prej...)', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Emerore, left: 'E.', middle1: 'një', middle2: 'i' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Gjinore, left: 'Gj. (i...)', middle1: 'një', middle2: 'të' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Dhanore, left: 'Dh.', middle1: 'një', middle2: 'të' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Kallezore, left: 'K.', middle1: 'një', middle2: 'të' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Rrjedhore, left: 'Rr. (prej...)', middle1: 'një', middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Emerore, left: 'E.', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Gjinore, left: 'Gj. (i...)', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Dhanore, left: 'Dh.', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Kallezore, left: 'K.', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Rrjedhore, left: 'Rr. (prej...)', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Emerore, left: 'E.', middle1: 'ca', middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Gjinore, left: 'Gj. (i...)', middle1: 'ca', middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Dhanore, left: 'Dh.', middle1: 'ca', middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Kallezore, left: 'K.', middle1: 'ca', middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Rrjedhore, left: 'Rr. (prej...)', middle1: 'ca', middle2: 'të' },
  ];

  public static EmriLakimiStructureFemerore = [
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Emerore, left: 'E.', middle1: null, middle2: 'e' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Gjinore, left: 'Gj. (i...)', middle1: null, middle2: 'së' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Dhanore, left: 'Dh.', middle1: null, middle2: 'së' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Kallezore, left: 'K.', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Rrjedhore, left: 'Rr. (prej...)', middle1: null, middle2: 'së' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Emerore, left: 'E.', middle1: 'një', middle2: 'e' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Gjinore, left: 'Gj. (i...)', middle1: 'një', middle2: 'të' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Dhanore, left: 'Dh.', middle1: 'një', middle2: 'të' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Kallezore, left: 'K.', middle1: 'një', middle2: 'të' },
    { numriId: EmriNumri.Njejes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Rrjedhore, left: 'Rr. (prej...)', middle1: 'një', middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Emerore, left: 'E.', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Gjinore, left: 'Gj. (i...)', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Dhanore, left: 'Dh.', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Kallezore, left: 'K.', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Eshquar, rasaId: EmriRasa.Rrjedhore, left: 'Rr. (prej...)', middle1: null, middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Emerore, left: 'E.', middle1: 'ca', middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Gjinore, left: 'Gj. (i...)', middle1: 'ca', middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Dhanore, left: 'Dh.', middle1: 'ca', middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Kallezore, left: 'K.', middle1: 'ca', middle2: 'të' },
    { numriId: EmriNumri.Shumes, trajtaId: EmriTrajta.Epashquar, rasaId: EmriRasa.Rrjedhore, left: 'Rr. (prej...)', middle1: 'ca', middle2: 'të' },
  ];

  public static GetFormulas(baza: string, lakimi: EmriLakimi, prapashtesa: EmriPrapashtesa, manualInput?: string) {
    switch (lakimi) {
      case EmriLakimi.Ipare: {
        switch (prapashtesa) {
          //nxënës
          case EmriPrapashtesa.sinjeejeesi: {
            let E1 = baza;
            return { E1 };
          }
          //çallmëbardhë
          case EmriPrapashtesa.sinjeejeesiee: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ë', '');
            let E3 = E1;
            return { E1, E2, E3 };
          }
          //gabim
          case EmriPrapashtesa.e: {
            let E1 = baza;
            let E3 = E1 + 'e';
            return { E1, E3 };
          }
          //cikël
          case EmriPrapashtesa.eee: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ë');
            let E3 = E2 + 'e';
            return { E1, E2, E3 };
          }
          //libër
          case EmriPrapashtesa.aee: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ë');
            let E3 = E2 + 'a';
            return { E1, E2, E3 };
          }
          //bel
          case EmriPrapashtesa.a: {
            let E1 = baza;
            let E3 = E1 + 'a';
            return { E1, E3 };
          }
          //anëtar
          case EmriPrapashtesa.ee: {
            let E1 = baza;
            let E3 = E1 + 'ë';
            return { E1, E3 };
          }
          //kalli
          case EmriPrapashtesa.nj: {
            let E1 = baza;
            let E2 = E1 + 'r';
            let E3 = E1 + 'nj';
            return { E1, E2, E3 };
          }
          //drapër
          case EmriPrapashtesa.injmereenieteeee: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ë');
            let E3a = E1.replaceLastOccurrence('ër') + 'inj';
            let E3b = E1 + 'inj';
            return { E1, E2, E3a, E3b };
          }
          //shkëmb
          case EmriPrapashtesa.inj: {
            let E1 = baza;
            let E3 = E1 + 'inj';
            return { E1, E3 };
          }
          //kalama
          case EmriPrapashtesa.jzgjerimiN: {
            let E1 = baza;
            let E2 = E1 + 'n';
            let E3 = E1 + 'nj';
            return { E1, E2, E3 };
          }
          //kufi
          case EmriPrapashtesa.jzgjerimiR: {
            let E1 = baza;
            let E2 = E1 + 'r';
            let E3 = E1 + 'j';
            return { E1, E2, E3 };
          }
          //lumë
          case EmriPrapashtesa.enj: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ë');
            let E3 = E2 + 'enj';
            return { E1, E2, E3 };
          }
          //mbret
          case EmriPrapashtesa.eer: {
            let E1 = baza;
            let E3 = E1 + 'ër';
            return { E1, E3 };
          }
          //bar I
          case EmriPrapashtesa.ra: {
            let E1 = baza;
            let E3 = E1 + 'ëra';
            return { E1, E3 };
          }
          //bar II
          case EmriPrapashtesa.na: {
            let E1 = baza;
            let E3 = E1 + 'na';
            return { E1, E3 };
          }
          //akull
          case EmriPrapashtesa.qiellzorizimllj: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('ll', 'j');
            return { E1, E3 };
          }
          //bir
          case EmriPrapashtesa.qiellzorizimrj: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('r', 'j');
            return { E1, E3 };
          }
          //mashkull
          case EmriPrapashtesa.qiellzorizimlljdhendeerrimzanorjaeparee: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('a', 'e').replaceLastOccurrence('ll', 'j');
            return { E1, E3 };
          }
          //bakall
          case EmriPrapashtesa.qiellzorizimlljdhendeerrimzanorjaedytee: {
            let E1 = baza;
            let E3a = E1.replaceLastOccurrence('a', 'e').replaceLastOccurrence('ll', 'j');
            let E3b = E1.replaceLastOccurrence('ll', 'j');
            return { E1, E3a, E3b };
          }
          //ftua
          case EmriPrapashtesa.ndeerrimzanoreuaoNJ: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ua', 'o');
            let E3 = E2 + 'nj';
            return { E1, E2, E3 };
          }
          //truall
          case EmriPrapashtesa.qiellzorizimlljndeerrimzanoreshE: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('ua', 'o').replaceLastOccurrence('ll', 'j') + 'e';

            return { E1, E3 };
          }
          //cjap
          case EmriPrapashtesa.ae: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('a', 'e');
            return { E1, E3 };
          }
          //thes
          case EmriPrapashtesa.ea: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('e', 'a') + 'ë';
            return { E1, E3 };
          }
          //vit
          case EmriPrapashtesa.ie: {
            let E1 = baza;
            let E3a = E1 + 'e';
            let E3b = E1.replaceLastOccurrence('i', 'je');
            return { E1, E3a, E3b };
          }
          //dhëndërr
          case EmriPrapashtesa.ndeerrimzanoresheeuee: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ë');
            let E3 = E2.replaceLastOccurrence('r') + 'urë';
            return { E1, E2, E3 };
          }
          //gardh
          case EmriPrapashtesa.qiellzorizimggjE: {
            let E1 = baza;
            let E2 = E1;
            let E3 = E1 + 'e';
            let E4 = E1.replaceLastOccurrence('g', 'gj').replaceLastOccurrence('a', 'e') + 'e';
            return { E1, E2, E3, E4 };
          }
          //djalë
          case EmriPrapashtesa.mepeerbeerjepjeseerishtteenjeejteeoseteendryshmeMANUALISHT: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ë');
            return { E1, E2 };
          }
        }
        break;
      }
      case EmriLakimi.Idyte: {
        switch (prapashtesa) {
          //lek
          case EmriPrapashtesa.ee: {
            let E1 = baza;
            let E3 = E1 + 'ë'
            return { E1, E3 };
          }
          //borxhli
          case EmriPrapashtesa.nj: {
            let E1 = baza;
            let E2 = E1;
            let E3 = E1 + 'nj';
            return { E1, E2, E3 };
          }
          //gjak
          case EmriPrapashtesa.ra: {
            let E1 = baza;
            let E3a = E1 + 'ra';
            let E3b = E1.replaceLastOccurrence('k', 'q') + 'e';
            return { E1, E3a, E3b };
          }
          //mik
          case EmriPrapashtesa.veteemmeqiellzorizimkq: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('k', 'q');
            return { E1, E3 };
          }
          //zog
          case EmriPrapashtesa.veteemmeqiellzorizimggj: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('g', 'gj');
            return { E1, E3 };
          }
          //bllok
          case EmriPrapashtesa.veteemmeqiellzorizimkqE: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('k', 'q') + 'e';
            return { E1, E3 };
          }
          //lëng
          case EmriPrapashtesa.veteemmeqiellzorizimggjE: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('g', 'gj') + 'e';
            return { E1, E3 };
          }
          //breg
          case EmriPrapashtesa.meqiellzorizimggjndeerrimzanorejeeiE: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('e', 'i').replaceLastOccurrence('g', 'gj') + 'e';
            return { E1, E3 };
          }
          //lak
          case EmriPrapashtesa.meqiellzorizimkqndeerrimzanorejeaeE: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('a', 'e').replaceLastOccurrence('k', 'q') + 'e';
            return { E1, E3 };
          }
          //ka
          case EmriPrapashtesa.mepeerbeerjepjeseerishtteenjeejteeoseteendryshmeMANUALISHT: {
            let E1 = baza;
            let E2 = baza;
            return { E1, E2 };
          }
        }
        break;
      }
      case EmriLakimi.Itrete: {
        switch (prapashtesa) {
          //këngë
          case EmriPrapashtesa.sinjeejeesiA: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ë');
            return { E1, E2 };
          }
          //nxënëse
          case EmriPrapashtesa.sinjeejeesiJA: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('e');
            let E3 = E1;
            return { E1, E2, E3 };
          }
          //mbledhje
          case EmriPrapashtesa.sinjeejeesiJE: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('e');
            return { E1, E2 };
          }
          //borxhlie
          case EmriPrapashtesa.sinjeejeesiIE: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('e');
            let E3 = E1;
            return { E1, E2, E3 };
          }
          //vegane
          case EmriPrapashtesa.sinjeejeesiE: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('e');
            let E3 = E1;
            return { E1, E2, E3 }
          }
          //shtëpi
          case EmriPrapashtesa.sinjeejeesiTHEKSi: {
            let E1 = baza;
            let E2 = baza;
            let E3 = baza;
            return { E1, E2, E3 };
          }
          //sevda
          case EmriPrapashtesa.sinjeejeesiTHEKSae: {
            let E1 = baza;
            let E3 = E1;
            return { E1, E3 };
          }
          //depo
          case EmriPrapashtesa.sinjeejeesiTHEKS0: {
            let E1 = baza;
            let E3 = E1;
            return { E1, E3 };
          }
          //fushë
          case EmriPrapashtesa.a: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ë');
            let E3 = E2 + 'a';
            return { E1, E2, E3 };
          }
          //vegël
          case EmriPrapashtesa.aeel: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ë');
            let E3 = E2 + 'a';
            return { E1, E2, E3 };
          }
          //kumbull
          case EmriPrapashtesa.aull: {
            let E1 = baza;
            let E2 = E1;
            let E3 = E2 + 'a';
            return { E1, E2, E3 };
          }
          //e drejta
          case EmriPrapashtesa.aNYJeeee: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ë');
            let E3 = E2 + 'a';
            return { E1, E2, E3 };
          }
          //e çelur
          case EmriPrapashtesa.aNYJee: {
            let E1 = baza;
            let E2 = baza;
            let E3 = E1 + 'a';
            return { E1, E2, E3 };
          }
          //verë I
          case EmriPrapashtesa.ra: {
            let E1 = baza;
            let E2 = E1.replaceLastOccurrence('ë');
            let E3 = E1 + 'ra';
            return { E1, E2, E3 };
          }
          //grua
          case EmriPrapashtesa.mepeerbeerjepjeseerishtteenjeejteeoseteendryshmeMANUALISHT: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('ua', 'a');
            return { E1, E3 };
          }
        }
        break;
      }
      case EmriLakimi.Ikatert: {
        switch (prapashtesa) {
          //të folurit
          case EmriPrapashtesa.pjesoreteeemeerzuaraIT: {
            let E1 = baza;
            return { E1 };
          }
          //të qarët
          case EmriPrapashtesa.pjesoreteeemeerzuaraeeT: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('ë');
            return { E1, E3 };
          }
          //të nxehtët
          case EmriPrapashtesa.mbiemraasnjaneesteeemeerzuar: {
            let E1 = baza;
            let E3 = E1.replaceLastOccurrence('ë');
            return { E1, E3 };
          }
        }
        break;
      }
    }
    throw new Error('Formula not implemented!');
  }
}
